export default __webpack_public_path__ + "static/screenFourthSectionRuBig-65ad401c59f6049f6eff473365b785e5.webp";